import React, { useMemo, useState } from "react";
import { Button } from "../../Components/UI/ui";
import { money, estimateAmount, cap } from "../../lib/lab";

// Line-item editor shared by booking and walk-in invoice forms.
// lines: [{ labSkuId, name, kind, unitPrice, tax, homeCollectionAvailable, qty, discount }]
const SkuLines = ({ skus, serviceType, lines, onChange, qtyLabel = "Qty", showEstimate = true }) => {
  const [search, setSearch] = useState("");

  const options = useMemo(() => {
    const s = search.trim().toLowerCase();
    return skus
      .filter((k) => k.isActive !== false)
      .filter((k) => !serviceType || k.serviceType === serviceType)
      .filter((k) => !lines.some((l) => l.labSkuId === k._id))
      .filter((k) => !s || k.name.toLowerCase().includes(s) || (k.category || "").toLowerCase().includes(s) || (k.labSkuId || "").toLowerCase().includes(s))
      .slice(0, 8);
  }, [skus, serviceType, lines, search]);

  const add = (k) => {
    onChange([...lines, { labSkuId: k._id, code: k.labSkuId, name: k.name, kind: k.kind, category: k.category, unitPrice: k.unitPrice, tax: k.tax, homeCollectionAvailable: k.homeCollectionAvailable, qty: 1, discount: 0 }]);
    setSearch("");
  };
  const update = (i, patch) => onChange(lines.map((l, j) => (j === i ? { ...l, ...patch } : l)));
  const remove = (i) => onChange(lines.filter((_, j) => j !== i));
  const est = estimateAmount(lines);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <div style={{ position: "relative" }}>
        <input
          className="lab-input w-full"
          placeholder={serviceType ? `Add ${serviceType} test / panel / scan…` : "Add test / panel / scan…"}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        {search && (
          <div className="lab-list" style={{ position: "absolute", left: 0, right: 0, top: 44, zIndex: 5, background: "#fff", padding: 6, borderRadius: 8, boxShadow: "0 8px 24px rgba(0,0,0,.15)" }}>
            {options.length === 0 && <div className="lab-muted" style={{ padding: 8 }}>No matching active SKU</div>}
            {options.map((k) => (
              <div key={k._id} className="lab-list__item" onClick={() => add(k)}>
                <div>
                  <div style={{ fontWeight: 600 }}>{k.name}</div>
                  <div className="lab-muted">{cap(k.kind)} · {k.category || "—"} · {k.labSkuId}</div>
                </div>
                <span>{money(k.unitPrice)}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {lines.length > 0 && (
        <table className="lab-lines">
          <thead>
            <tr>
              <th>Item</th>
              <th style={{ textAlign: "right" }}>Price</th>
              <th>{qtyLabel}</th>
              <th>Disc %</th>
              <th style={{ textAlign: "right" }}>Line</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {lines.map((l, i) => {
              const one = estimateAmount([l]);
              return (
                <tr key={l.labSkuId}>
                  <td>
                    <div style={{ fontWeight: 600 }}>{l.name}</div>
                    <div className="lab-muted">{cap(l.kind)}{l.homeCollectionAvailable ? " · home collection" : ""}</div>
                  </td>
                  <td className="num">{money(l.unitPrice)}</td>
                  <td><input type="number" min="1" className="lab-input sm" value={l.qty} onChange={(e) => update(i, { qty: Math.max(1, Number(e.target.value) || 1) })} /></td>
                  <td><input type="number" min="0" max="100" className="lab-input sm" value={l.discount} onChange={(e) => update(i, { discount: Math.min(100, Math.max(0, Number(e.target.value) || 0)) })} /></td>
                  <td className="num">{money(one.total)}</td>
                  <td><Button variant="ghost" size="xs" onClick={() => remove(i)}>✕</Button></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      {showEstimate && lines.length > 0 && (
        <div style={{ marginLeft: "auto", minWidth: 240 }}>
          <div className="lab-total"><span>Subtotal</span><span>{money(est.subtotal)}</span></div>
          <div className="lab-total"><span>Discount</span><span>− {money(est.discount)}</span></div>
          <div className="lab-total"><span>Tax</span><span>{money(est.tax)}</span></div>
          <div className="lab-total grand"><span>Estimated total</span><span>{money(est.total)}</span></div>
        </div>
      )}
    </div>
  );
};

export default SkuLines;
